import { render, staticRenderFns } from "./GolStatsDataFull.vue?vue&type=template&id=397d642d&scoped=true&"
import script from "./GolStatsDataFull.vue?vue&type=script&lang=js&"
export * from "./GolStatsDataFull.vue?vue&type=script&lang=js&"
import style0 from "./GolStatsDataFull.vue?vue&type=style&index=0&id=397d642d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397d642d",
  null
  
)

export default component.exports